// @ts-nocheck
import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { CrossLargeIcon } from '@pleio/icons/cross-large'

import Flexer from 'js/components/Flexer/Flexer'
import { Container } from 'js/components/Grid'
import IconButton from 'js/components/IconButton'
import Text from 'js/components/Text/Text'
import { createCookie, readCookie } from 'js/lib/cookies'

import styles from './CookieNotification.module.css'

const CookieNotification = () => {
    const [isHidden, setIsHidden] = useState(readCookie('cookieConsent'))

    const hideNotification = () => {
        createCookie('cookieConsent', true, 365)
        setIsHidden(true)
    }

    const { t } = useTranslation()

    if (isHidden) {
        return null
    }

    return (
        <div className={styles.wrapper}>
            <Container size="large">
                <Flexer>
                    <Text size="small">
                        <Trans i18nKey="global.cookie-notification">
                            Cookieverklaring
                            <a
                                href="https://support.pleio.nl/page/view/b416f2af-2009-481e-b3c2-c269e7fddd85/info-contact/22738c9c-d591-40e2-a5a1-0a7d930db0fa"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                link
                            </a>
                        </Trans>
                    </Text>
                    <IconButton
                        size="large"
                        variant="secondary"
                        onClick={hideNotification}
                        aria-label={t('global.cookie-notification-close')}
                    >
                        <CrossLargeIcon />
                    </IconButton>
                </Flexer>
            </Container>
        </div>
    )
}

export default CookieNotification
